import { t } from '@hefe/i18n';
import { AnalysisIssueEvent } from '@hefe/models';
import { formatDateTime, formatTime } from '@hefe/utils';
import { Flex, Typography } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import IssueAssignmentTagComponent from '../issue-assignment-tag/issue-assignment-tag.component';

interface IssueEventBlockComponentProps {
  event: AnalysisIssueEvent;
}

export default function IssueEventBlockComponent(
  props: IssueEventBlockComponentProps
) {
  const { event } = props;

  const endDate = useMemo(() => {
    const startDate = dayjs(event?.date);
    const endDate = dayjs(event?.end_date);

    if (startDate.isSame(endDate, 'day')) {
      return formatTime(endDate.toISOString());
    }

    return formatDateTime(endDate.toISOString(), { withWeekday: 'short' });
  }, [event?.date, event?.end_date]);

  const title = useMemo(() => {
    if (event?.type === 'basketball_practice') {
      return t('practices.singular');
    }

    return event?.title;
  }, [event?.type, event?.title]);

  return (
    <div
      style={{
        padding: '10px 12px',
        background: 'rgba(0, 0, 0, 0.025)',
        borderRadius: 8,
      }}
    >
      <Typography.Text strong>{title}</Typography.Text>

      <Typography.Text
        type="secondary"
        style={{ display: 'block', fontSize: 12, marginTop: 2 }}
      >
        {formatDateTime(event?.date, { withWeekday: 'short' })} – {endDate}
      </Typography.Text>

      <Flex gap={6} wrap style={{ marginTop: 8 }}>
        {event?.user_assignments.map((assignment, index) => (
          <IssueAssignmentTagComponent
            key={`${assignment.role}-${assignment.groupId}-${index}`}
            assignment={assignment}
          />
        ))}
      </Flex>
    </div>
  );
}
